import type { RouteRecordRaw } from "vue-router";
import type { MjfRouteMeta } from "@shared/types/localTypes/router";
import { RouteNames } from "@shared/types/localTypes/router";
import { impersonateLogin } from "@/router/guard/impersonate-login.ts";

// Deliberately a top-level record and not a child of "/auth": vue-router merges parent meta,
// and "/auth" is marked isGuest, which bounces users who still have a session - the exact case
// this route exists to handle.
export default {
  path: "/impersonate-login",
  name: RouteNames.ImpersonateLogin,
  component: () => import("@/views/login/LoginBase.vue"),
  meta: { hideLayout: true } as MjfRouteMeta,
  beforeEnter: impersonateLogin,
} as RouteRecordRaw;
